import { render } from "./ButtonClose.vue?vue&type=template&id=e12b10bc"
import script from "./ButtonClose.vue?vue&type=script&lang=js"
export * from "./ButtonClose.vue?vue&type=script&lang=js"

import "./ButtonClose.vue?vue&type=style&index=0&id=e12b10bc&lang=css"

import exportComponent from "/home/nimens/projects/cafe-portos/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__